import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import './MenuWizard.css'
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { pages } from '../../../wizard/utils';
const MenuWizard = ({ activePage, setActivePage }) => {

    const handlePageChange = (page) => {
        setActivePage(page);
    }

    return (
        <Container>
            <Row>
                <Col>
                    <ul className="menuWizard">
                        <li>
                            <Link to={`/wizard`} className={activePage === pages.pagos ? 'active' : ''} onClick={() => handlePageChange(pages.pagos)}>Pagos y Facturación</Link>
                        </li>
                        <li>
                            <Link to={`/wizard`} className={activePage === pages.contacto ? 'active' : ''} onClick={() => handlePageChange(pages.contacto)}>Información de Contacto</Link>
                        </li>
                        <li>
                            <Link to={`/wizard`} className={activePage === pages.unidades ? 'active' : ''} onClick={() => handlePageChange(pages.unidades)}>Unidades de Negocio</Link>
                        </li>
                        <li>
                            <Link to={`/wizard`} className={activePage === pages.usuarios ? 'active' : ''} onClick={() => handlePageChange(pages.usuarios)}>Usuarios y Accesos</Link>
                        </li>
                        <li>
                            <Link to={`/wizard`} className={activePage === pages.asistencia ? 'active' : ''} onClick={() => handlePageChange(pages.asistencia)}>Solicitar Asistencia</Link>
                        </li>
                    </ul>
                </Col>
            </Row>
        </Container>
    );
};

export default MenuWizard;